/* eslint-disable sort-keys */
/* eslint-disable max-lines */
import {Category} from 'models';
import {ICategorySection} from 'modules/categories/types';

export const CATEGORY_LEVEL = {
    FIRST: 1,
    SECOND: 2,
    THIRD: 3,
};

export const CATEGORY_TYPE: Record<string, Category['type']> = {
    COLLECTION: 'collection',
    MIXED: 'mixed',
    SIMPLE: 'simple',
    TECHNICAL: 'technical',
    VISUAL: 'visual',
};

export const MOCK_CATEGORIES: ICategorySection[] = [
    {
        banners: [
            {
                code: '/catalog/vino/filter/color-beloe/',
                img: '/images/category-banners/white.webp',
                title: 'Белое<br/>вино',
            },
            {
                code: '/catalog/vino/filter/color-krasnoe/',
                img: '/images/category-banners/red.webp',
                title: 'Красное<br/>вино',
            },
            {
                code: '/catalog/vino/filter/color-rozovoe/',
                img: '/images/category-banners/rose.webp',
                title: 'Розовое<br/>вино',
            },
        ],
        categories: [
            {
                categoriesColumn: [
                    {
                        categoryType: 'Цена',
                        list: [
                            {
                                categoryName: 'До 1 000 ₽',
                                code: '',
                                href: '/catalog/vino/filter/main-to-1000/',
                            },
                            {
                                categoryName: 'От 1 000 до 3 000 ₽',
                                code: '',
                                href: '/catalog/vino/filter/main-from-1000-to-3000/',
                            },
                            {
                                categoryName: 'От 3 000 до 6 000 ₽',
                                code: '',
                                href: '/catalog/vino/filter/main-from-3000-to-6000/',
                            },
                            {
                                categoryName: 'От 6 000 до 10 000 ₽',
                                code: '',
                                href: '/catalog/vino/filter/main-from-6000-to-10000/',
                            },
                            {
                                categoryName: 'От 10 000 до 20 000 ₽',
                                code: '',
                                href: '/catalog/vino/filter/main-from-10000-to-20000/',
                            },
                            {
                                categoryName: 'От 20 000 ₽',
                                code: '',
                                href: '/catalog/vino/filter/main-from-20000/',
                            },
                        ],
                    },
                    {
                        categoryType: 'Ещё вина',
                        list: [
                            {
                                categoryName: 'Оранжевое',
                                code: '',
                                href: '/catalog/vino/filter/orange-1/',
                            },
                            {
                                categoryName: 'Безалкогольное',
                                code: '',
                                href: '/catalog/vino/filter/bezalkogolnoe-1/',
                            },
                            {
                                categoryName: 'Портвейн',
                                code: '',
                                href: '/catalog/vino/filter/strong_wine-portveyn/',
                            },
                            {
                                categoryName: 'Херес',
                                code: '',
                                href: '/catalog/vino/filter/strong_wine-kheres/',
                            },
                        ],
                    },
                ],
            },
            {
                categoriesColumn: [
                    {
                        categoryType: 'Содержание сахара',
                        list: [
                            {
                                categoryName: 'Сухое',
                                code: '',
                                href: '/catalog/vino/filter/sugar_type-sukhoe/',
                            },
                            {
                                categoryName: 'Полусухое',
                                code: '',
                                href: '/catalog/vino/filter/sugar_type-polusukhoe/',
                            },
                            {
                                categoryName: 'Полусладкое',
                                code: '',
                                href: '/catalog/vino/filter/sugar_type-polusladkoe/',
                            },
                            {
                                categoryName: 'Сладкое',
                                code: '',
                                href: '/catalog/vino/filter/sugar_type-sladkoe/',
                            },
                        ],
                    },
                    {
                        categoryType: 'Сорт винограда',
                        list: [
                            {
                                categoryName: 'Совиньон блан',
                                code: '',
                                href: '/catalog/vino/filter/grape-sovinon_blan/',
                            },
                            {
                                categoryName: 'Пино нуар',
                                code: '',
                                href: '/catalog/vino/filter/grape-pino_nuar/',
                            },
                            {
                                categoryName: 'Рислинг',
                                code: '',
                                href: '/catalog/vino/filter/grape-risling-or-risling_reynskiy/',
                            },
                            {
                                categoryName: 'Шардоне',
                                code: '',
                                href: '/catalog/vino/filter/grape-shardone/',
                            },
                            {
                                categoryName: 'Каберне совиньон',
                                code: '',
                                href: '/catalog/vino/filter/grape-kaberne_sovinon/',
                            },
                            {
                                categoryName: 'Мальбек',
                                code: '',
                                href: '/catalog/vino/filter/grape-malbek/',
                            },
                            {
                                categoryName: 'Темпранильо',
                                code: '',
                                href: '/catalog/vino/filter/grape-tempranilo/',
                            },
                        ],
                    },
                ],
            },
            {
                categoriesColumn: [
                    {
                        categoryType: 'Страна',
                        list: [
                            {
                                categoryName: 'Италия',
                                code: '',
                                href: '/catalog/vino/filter/country-italiya/',
                                src: '/images/flags/italy.webp',
                            },
                            {
                                categoryName: 'Франция',
                                code: '',
                                href: '/catalog/vino/filter/country-frantsiya/',
                                src: '/images/flags/france.webp',
                            },
                            {
                                categoryName: 'Испания',
                                code: '',
                                href: '/catalog/vino/filter/country-ispaniya/',
                                src: '/images/flags/spain.webp',
                            },
                            {
                                categoryName: 'Россия',
                                code: '',
                                href: '/catalog/vino/filter/country-rossiya/',
                                src: '/images/flags/russia.webp',
                            },
                            {
                                categoryName: 'Германия',
                                code: '',
                                href: '/catalog/vino/filter/country-germaniya/',
                                src: '/images/flags/germany.webp',
                            },
                            {
                                categoryName: 'Аргентина',
                                code: '',
                                href: '/catalog/vino/filter/country-argentina/',
                                src: '/images/flags/argentina.webp',
                            },
                            {
                                categoryName: 'Чили',
                                code: '',
                                href: '/catalog/vino/filter/country-chili/',
                                src: '/images/flags/chili.webp',
                            },
                            {
                                categoryName: 'ЮАР',
                                code: '',
                                href: '/catalog/vino/filter/country-yuzhnaya_afrika/',
                                src: '/images/flags/uar.webp',
                            },
                        ],
                    },
                    {
                        categoryType: 'Философия производства',
                        list: [
                            {
                                categoryName: 'Органика',
                                code: '',
                                href: '/catalog/vino/filter/cultivation_type-organika/',
                            },
                            {
                                categoryName: 'Биодинамика',
                                code: '',
                                href: '/catalog/vino/filter/cultivation_type-biodinamika/',
                            },
                            {
                                categoryName: 'Sustainable',
                                code: '',
                                href: '/catalog/vino/filter/cultivation_type-sustainable/',
                            },
                        ],
                    },
                ],
            },
        ],
        code: 'wine',
        id: 1,
        name: 'Вино',
        nameAll: 'Всё вино',
        sectionLink: '/catalog/vino/',
        presentLink: '/catalog/vino/filter/present_pack-1/',
    },
    {
        banners: [
            {
                code: '/catalog/shampanskoe_i_igristoe_vino/filter/region-shampan/',
                img: '/images/category-banners/champagne.webp',
                title: 'Шампанское',
            },
            {
                code: '/catalog/shampanskoe_i_igristoe_vino/filter/country-italiya/appellason-prosecco_doc-or-prosecco_valdobbiadene_superiore_docg/grape-glera/',
                img: '/images/category-banners/prosekko.webp',
                title: 'Просекко',
            },
        ],
        categories: [
            {
                categoriesColumn: [
                    {
                        categoryType: 'Цена',
                        list: [
                            {
                                categoryName: 'До 1 000 ₽',
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/main-to-1000/',
                            },
                            {
                                categoryName: 'От 1 000 до 3 000 ₽',
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/main-from-1000-to-3000/',
                            },
                            {
                                categoryName: 'От 3 000 до 6 000 ₽',
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/main-from-3000-to-6000/',
                            },
                            {
                                categoryName: 'От 6 000 до 10 000 ₽',
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/main-from-6000-to-10000/',
                            },
                            {
                                categoryName: 'От 10 000 до 20 000 ₽',
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/main-from-10000-to-20000/',
                            },
                            {
                                categoryName: 'От 20 000 ₽',
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/main-from-20000/',
                            },
                        ],
                    },
                    {
                        categoryType: 'Бренды',
                        list: [
                            {
                                categoryName: 'Brimoncourt',
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/manufacturer-brimoncourt/',
                            },
                            {
                                categoryName: 'Bruni',
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/manufacturer-bruni/',
                            },
                            {
                                categoryName: 'Lanson',
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/manufacturer-lanson/',
                            },
                            {
                                categoryName: 'Louis Roederer',
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/manufacturer-louis_roederer/',
                            },
                            {
                                categoryName: "Ca'del Bosco",
                                code: '',
                                href: '/catalog/shampanskoe_i_igristoe_vino/filter/manufacturer-ca_del_bosco/',
                            },
                            // {
                            //     categoryName: 'Ruggeri',
                            //     code: '',
                            //     href: '/catalog/shampanskoe_i_igristoe_vino/filter/manufacturer-ruggeri/',
                            // },
                        ],
                    },
                ],
            },
            {
                categoryType: 'Содержание сахара',
                list: [
                    {
                        categoryName: 'Экстра брют',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/filter/sugar_type-ekstra_bryut/',
                    },
                    {
                        categoryName: 'Брют',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/filter/sugar_type-sukhoe/',
                    },
                    {
                        categoryName: 'Полусухое',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/filter/sugar_type-polusukhoe/',
                    },
                    {
                        categoryName: 'Полусладкое',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/filter/sugar_type-polusladkoe/',
                    },
                    {
                        categoryName: 'Сладкое',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/filter/sugar_type-sladkoe/',
                    },
                ],
            },
            {
                categoryType: 'Тип',
                list: [
                    {
                        categoryName: 'Шампанское',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/shampanskoe/',
                    },
                    {
                        categoryName: 'Просекко',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/filter/country-italiya/appellason-prosecco_doc-or-prosecco_valdobbiadene_superiore_docg/grape-glera/',
                    },
                    {
                        categoryName: 'Креман',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/igristoe-vino/filter/appellason-cremant_d_alsace_aoc-or-cremant_de_bourgogne_aoc-or-cremant_de_limoux_aoc-or-montlouis_sur_loire_aoc-or-saumur_aoc/',
                    },
                    {
                        categoryName: 'Кава',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/filter/appellason-cava_do/',
                    },
                    {
                        categoryName: 'Зект',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/filter/country-avstriya-or-germaniya/',
                    },
                    {
                        categoryName: 'Асти',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/filter/appellason-asti_docg/',
                    },
                    {
                        categoryName: 'Франчакорта',
                        code: '',
                        href: '/catalog/shampanskoe_i_igristoe_vino/filter/country-italiya/appellason-franciacorta_docg/',
                    },
                ],
            },
        ],
        code: 'champagne',
        id: 2,
        name: 'Шампанское и игристое',
        nameAll: 'Всё шампанское и игристое',
        sectionLink: '/catalog/shampanskoe_i_igristoe_vino/',
        presentLink: '/catalog/shampanskoe_i_igristoe_vino/filter/present_pack-1/',
    },
    {
        banners: [
            {
                code: '/catalog/ksn/viski/',
                img: '/images/category-banners/viski-banner.webp',
                title: 'Виски',
            },
            {
                code: '/catalog/ksn/konyak/',
                img: '/images/category-banners/konyak-banner.webp',
                title: 'Коньяк',
            },
        ],
        categories: [
            {
                categoryType: 'Цена',
                list: [
                    {
                        categoryName: 'До 3 000 ₽',
                        code: '',
                        href: '/catalog/ksn/filter/main-to-3000/',
                    },
                    {
                        categoryName: 'От 3 000 до 6 000 ₽',
                        code: '',
                        href: '/catalog/ksn/filter/main-from-3000-to-6000/',
                    },
                    {
                        categoryName: 'От 6 000 до 10 000 ₽',
                        code: '',
                        href: '/catalog/ksn/filter/main-from-6000-to-10000/',
                    },
                    {
                        categoryName: 'От 10 000 до 20 000 ₽',
                        code: '',
                        href: '/catalog/ksn/filter/main-from-10000-to-20000/',
                    },
                    {
                        categoryName: 'От 20 000 ₽',
                        code: '',
                        href: '/catalog/ksn/filter/main-from-20000/',
                    },
                ],
            },
            {
                categoryType: 'Тип',
                list: [
                    {
                        categoryName: 'Джин',
                        code: '',
                        href: '/catalog/ksn/dzhin/',
                    },
                    {
                        categoryName: 'Ром',
                        code: '',
                        href: '/catalog/ksn/rom/',
                    },
                    {
                        categoryName: 'Водка',
                        code: '',
                        href: '/catalog/ksn/vodka/',
                    },
                    {
                        categoryName: 'Арманьяк',
                        code: '',
                        href: '/catalog/ksn/armanyak/',
                    },
                    {
                        categoryName: 'Бренди',
                        code: '',
                        href: '/catalog/ksn/brendi/',
                    },
                    {
                        categoryName: 'Ликер',
                        code: '',
                        href: '/catalog/ksn/liker/',
                    },
                    {
                        categoryName: 'Текила',
                        code: '',
                        href: '/catalog/ksn/tekila/',
                    },
                    {
                        categoryName: 'Настойки',
                        code: '',
                        href: '/catalog/ksn/nastoyki/',
                    },
                ],
            },
            {
                categoryType: 'Бренды',
                list: [
                    {
                        categoryName: 'Camus',
                        code: '',
                        href: '/catalog/ksn/filter/manufacturer-camus/',
                    },
                    {
                        categoryName: 'Hine',
                        code: '',
                        href: '/catalog/ksn/filter/manufacturer-hine/',
                    },
                    {
                        categoryName: 'The Irishman',
                        code: '',
                        href: '/catalog/ksn/filter/manufacturer-the_irishman/',
                    },
                    {
                        categoryName: `Writers' Tears`,
                        code: '',
                        href: '/catalog/ksn/filter/manufacturer-writers_tears/',
                    },
                    {
                        categoryName: 'Bunnahabhain',
                        code: '',
                        href: '/catalog/ksn/filter/manufacturer-bunnahabhain/',
                    },
                    {
                        categoryName: 'Angostura',
                        code: '',
                        href: '/catalog/ksn/filter/manufacturer-angostura/',
                    },
                    {
                        categoryName: 'Portobello',
                        code: '',
                        href: '/catalog/ksn/filter/manufacturer-portobello/',
                    },
                    {
                        categoryName: 'Gin Mare',
                        code: '',
                        href: '/catalog/ksn/filter/manufacturer-gin_mare/',
                    },
                    {
                        categoryName: 'Онегин',
                        code: '',
                        href: '/catalog/ksn/filter/manufacturer-onegin/',
                    },
                ],
            },
        ],
        code: 'strong',
        id: 3,
        name: 'Крепкие напитки',
        nameAll: 'Все крепкие напитки',
        sectionLink: '/catalog/ksn/',
        presentLink: '/catalog/ksn/filter/present_pack-1/',
    },
    {
        banners: [
            {
                code: '/catalog/voda_i_soki/mineralnaya_voda/',
                img: '/images/category-banners/voda-default-wide.webp',
                title: 'Минеральная вода',
            },
            {
                code: '/catalog/voda_i_soki/soki/',
                img: '/images/category-banners/voda-sok-wide.webp',
                title: 'Соки',
            },
        ],
        categories: [
            {
                categoriesColumn: [
                    {
                        categoryType: 'Цена',
                        list: [
                            {
                                categoryName: 'До 1 000 ₽',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/main-to-1000/',
                            },
                            {
                                categoryName: 'От 1 000 до 3 000 ₽',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/main-from-1000-to-3000/',
                            },
                            {
                                categoryName: 'От 3 000 до 6 000 ₽',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/main-from-3000-to-6000/',
                            },
                            {
                                categoryName: 'От 6 000 до 10 000 ₽',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/main-from-6000-to-10000/',
                            },
                        ],
                    },
                    {
                        categoryType: 'Бренды',
                        list: [
                            {
                                categoryName: 'San Benedetto',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/manufacturer-san_benedetto/',
                            },
                            {
                                categoryName: 'VOSS',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/manufacturer-voss/',
                            },
                            {
                                categoryName: 'Aqua Russa',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/manufacturer-aqua_russa/',
                            },
                            {
                                categoryName: 'Yoga',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/manufacturer-yoga/',
                            },
                            {
                                categoryName: 'Все бренды',
                                code: '',
                                href: '/catalog/voda_i_soki/',
                            },
                        ],
                    },
                ],
            },
            {
                categoriesColumn: [
                    {
                        categoryType: 'Газация',
                        list: [
                            {
                                categoryName: 'Газированная',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/drink_type-gazirovannaya/',
                            },
                            {
                                categoryName: 'Негазированная',
                                code: '',
                                href: '/catalog/voda_i_soki/mineralnaya_voda/filter/drink_type-negazirovannaya/',
                            },
                        ],
                    },
                    {
                        categoryType: 'Объем',
                        list: [
                            {
                                categoryName: '0,25 - 0,5 л',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/volume-0_2-or-0_25-or-0_33-or-0_375-or-0_5/',
                            },
                            {
                                categoryName: '0,5 - 0,8 л',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/volume-0_65-or-0_75-or-0_8/',
                            },
                            {
                                categoryName: '1 - 1,5 л',
                                code: '',
                                href: '/catalog/voda_i_soki/filter/volume-1-or-1_5/',
                            },
                        ],
                    },
                ],
            },
            {
                categoryType: 'Страна',
                list: [
                    {
                        categoryName: 'Италия',
                        code: '',
                        href: '/catalog/voda_i_soki/filter/country-italiya/',
                        src: '/images/flags/italy.webp',
                    },
                    {
                        categoryName: 'Норвегия',
                        code: '',
                        href: '/catalog/voda_i_soki/filter/country-norvegiya/',
                        src: '/images/flags/norway.webp',
                    },

                    {
                        categoryName: 'Россия',
                        code: '',
                        href: '/catalog/voda_i_soki/filter/country-rossiya/',
                        src: '/images/flags/russia.webp',
                    },
                ],
            },
        ],
        code: 'water',
        id: 4,
        name: 'Вода и соки',
        sectionLink: '/catalog/voda_i_soki/',
    },
    {
        banners: [
            {
                code: '/catalog/steklo/bokaly/',
                img: '/images/category-banners/steklo-bokal-wide.webp',
                title: 'Бокалы',
            },
            {
                code: '/catalog/steklo/dekantery/',
                img: '/images/category-banners/steklo-dekantera-wide.webp',
                title: 'Декантеры',
            },
        ],
        categories: [
            {
                categoriesColumn: [
                    {
                        categoryType: 'Цена',
                        list: [
                            {
                                categoryName: 'До 3 000 ₽',
                                code: '',
                                href: '/catalog/steklo/filter/main-to-3000/',
                            },
                            {
                                categoryName: 'От 3 000 до 6 000 ₽',
                                code: '',
                                href: '/catalog/steklo/filter/main-from-3000-to-6000/',
                            },
                            {
                                categoryName: 'От 6 000 до 10 000 ₽',
                                code: '',
                                href: '/catalog/steklo/filter/main-from-6000-to-10000/',
                            },
                            {
                                categoryName: 'От 10 000 до 20 000 ₽',
                                code: '',
                                href: '/catalog/steklo/filter/main-from-10000-to-20000/',
                            },
                            {
                                categoryName: 'От 20 000 ₽',
                                code: '',
                                href: '/catalog/steklo/filter/main-from-20000/',
                            },
                        ],
                    },
                    {
                        categoryType: 'Бренды',
                        list: [
                            {
                                categoryName: 'Spiegelau',
                                code: '',
                                href: '/catalog/steklo/filter/manufacturer-spiegelau/',
                            },
                            {
                                categoryName: 'Zalto',
                                code: '',
                                href: '/catalog/steklo/filter/manufacturer-zalto/',
                            },
                            {
                                categoryName: 'Josephine',
                                code: '',
                                href: '/catalog/steklo/filter/manufacturer-josephine/',
                            },
                        ],
                    },
                ],
            },
            {
                categoryType: 'Подходит',
                list: [
                    {
                        categoryName: 'Для красного вина',
                        code: '',
                        href: '/catalog/steklo/bokaly/dlya_vina/dlya_krasnogo_vina/',
                    },
                    {
                        categoryName: 'Для белого вина',
                        code: '',
                        href: '/catalog/steklo/bokaly/dlya_vina/dlya_belogo_vina/',
                    },
                    {
                        categoryName: 'Для шампанского',
                        code: '',
                        href: '/catalog/steklo/bokaly/dlya_shampanskogo/',
                    },
                    {
                        categoryName: 'Для крепких напитков',
                        code: '',
                        href: '/catalog/steklo/bokaly/dlya-krepkikh-napitkov/',
                    },
                    {
                        categoryName: 'Для коктейлей',
                        code: '',
                        href: '/catalog/steklo/filter/suitable-dlya_kokteyley/',
                    },
                    {
                        categoryName: 'Для пива',
                        code: '',
                        href: '/catalog/steklo/bokaly/dlya_piva/',
                    },
                    {
                        categoryName: 'Для воды',
                        code: '',
                        href: '/catalog/steklo/bokaly/dlya_mineralnoy_vody/',
                    },
                ],
            },
        ],
        code: 'glass',
        id: 5,
        name: 'Бокалы',
        sectionLink: '/catalog/steklo/',
    },
    {
        code: 'beautiful-words',
        id: 6,
        name: 'В подарок',
        sectionLink: 'https://simplewine.ru/stock/beautiful-words/',
        isMarked: true,
        categories: [
            {
                categoriesColumn: [
                    {
                        categoryType: 'Цена',
                        list: [
                            {
                                categoryName: 'От 1 000 до 3 000 ₽',
                                code: '',
                                href: 'https://simplewine.ru/stock/beautiful-words/filter/main-from-1000-to-3000',
                            },
                            {
                                categoryName: 'От 3 000 до 6 000 ₽',
                                code: '',
                                href: 'https://simplewine.ru/stock/beautiful-words/filter/main-from-3000-to-60000',
                            },
                            {
                                categoryName: 'От 6 000 до 10 000 ₽',
                                code: '',
                                href: 'https://simplewine.ru/stock/beautiful-words/filter/main-from-6000-to-10000',
                            },
                            {
                                categoryName: 'От 10 000 до 20 000 ₽',
                                code: '',
                                href: 'https://simplewine.ru/stock/beautiful-words/filter/main-from-10000-to-20000',
                            },
                            {
                                categoryName: 'От 20 000 ₽',
                                code: '',
                                href: 'https://simplewine.ru/stock/beautiful-words/filter/main-from-20000',
                            },
                        ],
                    },
                ],
            },
            {
                categoryType: 'Вино',
                list: [
                    {
                        categoryName: 'Красное',
                        code: '',
                        href: 'https://simplewine.ru/stock/beautiful-words/?tabId[]=krasnye-vina-beautiful-words',
                    },
                    {
                        categoryName: 'Белое и розовое',
                        code: '',
                        href: 'https://simplewine.ru/stock/beautiful-words/?tabId[]=belye-i-rozovye-vina-beautiful-words',
                    },
                    {
                        categoryName: 'Игристое',
                        code: '',
                        href: 'https://simplewine.ru/stock/beautiful-words/?tabId[]=igristye-vina-beautiful-words',
                    },
                    {
                        categoryName: 'Шампанское',
                        code: '',
                        href: 'https://simplewine.ru/stock/beautiful-words/?tabId[]=shampanskoe-beautiful-words',
                    },
                ],
            },
            {
                categoryType: 'Крепкие напитки',
                list: [
                    {
                        categoryName: 'Джин',
                        code: '',
                        href: 'https://simplewine.ru/stock/beautiful-words/filter/filter_category-dzhin',
                    },
                    {
                        categoryName: 'Порто и херес',
                        code: '',
                        href: 'https://simplewine.ru/stock/beautiful-words/filter/filter_category-kreplenoe_vino',
                    },
                    {
                        categoryName: 'Граппа',
                        code: '',
                        href: 'https://simplewine.ru/stock/beautiful-words/filter/filter_category-grappa',
                    },
                    {
                        categoryName: 'Ликеры',
                        code: '',
                        href: 'https://simplewine.ru/stock/beautiful-words/filter/filter_category-liker/?tabId[]=all',
                    },
                ],
            },
        ],
        banners: [
            {
                code: 'https://simplewine.ru/stock/beautiful-words/filter/filter_category-vino/',
                img: '/images/category-banners/beautiful-vino.webp',
                title: 'Тихие вина',
                background: 'linear-gradient(90deg, #E6B2D8 0%, #F3BEE5 100%)',
                className: 'vino',
            },
            {
                code: 'https://simplewine.ru/stock/beautiful-words/filter/filter_category-shampanskoe_i_igristoe/',
                img: '/images/category-banners/beautiful-shampanskoe.webp',
                title: 'Шампанское<br/>и игристое',
                background: 'linear-gradient(270deg, #EBE6D2 0%, #D6C9A6 100%)',
                className: 'shampanskoe',
            },
            {
                code: 'https://simplewine.ru/stock/beautiful-words/?tabId[]=bokaly-i-aksessuary-beautiful-words',
                img: '/images/category-banners/beautiful-steklo.webp',
                title: 'Бокалы и аксессуары',
                background: '#E8E9E9',
                className: 'steklo',
            },
            {
                code: 'https://simplewine.ru/stock/beautiful-words/filter/filter_category-viski/?tabId[]=viski-beautiful-words',
                img: '/images/category-banners/beautiful-viski.webp',
                title: 'Виски',
                background: 'linear-gradient(270deg, #FEC6A5 0%, #FDB49B 100%)',
                className: 'viski',
            },
            {
                code: 'https://simplewine.ru/stock/beautiful-words/?tabId[]=konyak-beautiful-words',
                img: '/images/category-banners/beautiful-konyak.webp',
                title: 'Коньяк',
                background: 'linear-gradient(270deg, #FDD277 0%, #FEC975 100%)',
                className: 'konyak',
            },
            {
                code: 'https://simplewine.ru/stock/beautiful-words/?tabId[]=krepkie-napitki-beautiful-words',
                img: '/images/category-banners/beautiful-ksn.webp',
                title: 'Крепкие<br/>напитки',
                background: '#F8ECD6',
                className: 'ksn',
            },
            {
                code: 'https://simplewine.ru/electronic-gift-certificates/',
                img: '/images/category-banners/beautiful-certificate.webp',
                title: 'Подарочные<br/>сертификаты',
                background: '#F0EDE7',
                className: 'certificate',
            },
        ],
    },
    {
        code: 'events',
        id: 7,
        name: 'Дегустации',
        link: '/events/',
    },
    {
        code: 'gurme',
        id: 8,
        name: 'Гурмэ',
        link: '/catalog/gurme/',
    },
    {
        code: 'fineandrare',
        id: 9,
        name: 'Fine & Rare',
        link: '/catalog/fineandrare/',
    },
    {
        code: 'discount',
        id: 10,
        name: 'Акции %',
        link: 'https://simplewine.ru/stock/discount/',
    },
];
